import React from "react"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import Widget from "../layout/widget/Widget"
import LineChart from "../charts/generic/LineChart"
import EngagementLineDataShape from "../../state/shapes/EngagementLineDataShape"
import { formatDecimalForDisplay } from "../../utils/formatting-utils"

function EngagementScoreLineChart({
  exportEndpoint,
  appliedFilters,
  data,
  subtitleKey,
  sampleSize,
  t
}) {
  const engagementScoreData = []
  const engagementCategories = []
  const series = []

  const formatTooltip = (context) => {
    if (context.point.count === 1) {
      return `<b>${context.x}:</b> 
      ${formatDecimalForDisplay(context.y)}% (${context.point.count} ${t("Common.Person")})`
    }

    return `<b>${context.x}:</b> 
    ${formatDecimalForDisplay(context.y)}% (${context.point.count} ${t("Common.People")})`
  }

  // If a reviewName was set that means we want the review name to be on the x axis (as no review
  // was specified), however if it wasn't then we are displaying data for a specific review and hence
  // the name isn't set.
  data.forEach((record) => {
    if (record.reviewName != null) {
      engagementCategories.push(record.reviewName)
      series.push({ y: record.engagementPercentage, count: record.responses })
    } else {
      engagementCategories.push(record.month)
      series.push({ y: record.engagementPercentage, count: record.responses })
    }
  })

  engagementScoreData.push({
    name: null,
    data: series
  })
  const titleKey="Widgets.EngagementScoreLineChart.Title"
  return (
    <Widget
      columns={2}
      titleKey={titleKey}
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
      helpKey="Widgets.EngagementScore.Help"
      sampleSize={sampleSize}
    >
      <LineChart
        data={engagementScoreData}
        categories={engagementCategories}
        chartPointStart={0}
        xAxisLabel="Common.Time"
        xTickInterval={1}
        yAxisLabel="Common.Percentage"
        yMinValue={0}
        yMaxValue={100}
        tooltipFormatter={formatTooltip}
        titleKey={titleKey}
        subtitleKey={subtitleKey}
      />
    </Widget>
  )
}

EngagementScoreLineChart.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(EngagementLineDataShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string,
  t: PropTypes.func.isRequired,
  sampleSize: PropTypes.object
}

EngagementScoreLineChart.defaultProps = {
  subtitleKey: null
}

export default translate()(EngagementScoreLineChart)



// WEBPACK FOOTER //
// ./src/components/widgets/EngagementScoreLineChart.jsx